// extracted by mini-css-extract-plugin
export var defaultWrapper = "_kr-3";
export var downloadButton = "_kr-4";
export var fileContainer = "_kr-9 _kr-7";
export var fileContainerBase = "_kr-7";
export var fileContainerBaseSm = "_kr-a _kr-7";
export var fileContainerFixedHeight = "_kr-8 _kr-7";
export var fileContainerFixedHeightSm = "_kr-c _kr-a _kr-7";
export var fileContainerSm = "_kr-b _kr-a _kr-7";
export var fileInfo = "_kr-5";
export var fileInfoWidthRestricted = "_kr-6";
export var fileType = "_kr-1";
export var fileTypeName = "_kr-2";
export var fileTypeSm = "_kr-d _kr-1";
export var image = "_kr-0";
export var link = "_kr-f";
export var overflowEllipsis = "_kr-e";